import { render } from "./DollarChart.vue?vue&type=template&id=020fd3f6&scoped=true&ts=true"
import script from "./DollarChart.vue?vue&type=script&lang=ts"
export * from "./DollarChart.vue?vue&type=script&lang=ts"

import "./DollarChart.vue?vue&type=style&index=0&id=020fd3f6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-020fd3f6"]])

export default __exports__